function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useContext } from 'react';
import { useMembershipInformation } from '@thd-olt-functional/customer-information';
import ExperienceContext from "../components/ExperienceContext.js";
export const useStore = function () {
  var _customer$type;
  let {
    varnish = true,
    online = true
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    store,
    clientStore,
    customer
  } = useContext(ExperienceContext);
  const cachedStoreId = online ? '8119' : '121';

  // eslint-disable-next-line no-nested-ternary
  let defaultStore = varnish ? {
    storeId: cachedStoreId,
    isLocalized: false
  } : store ? _objectSpread(_objectSpread({}, store), {}, {
    isLocalized: false
  }) : {
    storeId: cachedStoreId,
    isLocalized: false
  };
  const {
    apiResponse,
    customerType,
    isExchangeCustomer,
    isStorefrontCustomer
  } = useMembershipInformation({
    customerType: customer === null || customer === void 0 ? void 0 : (_customer$type = customer.type) === null || _customer$type === void 0 ? void 0 : _customer$type.toUpperCase()
  });
  if ((customerType === 'B2B' || isExchangeCustomer || isStorefrontCustomer) && clientStore) {
    if (apiResponse !== null && apiResponse !== void 0 && apiResponse.data || apiResponse !== null && apiResponse !== void 0 && apiResponse.error) {
      defaultStore = _objectSpread(_objectSpread(_objectSpread({}, defaultStore), clientStore), {}, {
        isLocalized: true,
        membershipInformation: _objectSpread({}, apiResponse)
      });
    }
  } else if (clientStore) {
    defaultStore = _objectSpread(_objectSpread(_objectSpread({}, defaultStore), clientStore), {}, {
      isLocalized: true
    });
  }
  return defaultStore;
};
//# sourceMappingURL=useStore.js.map